import { createMemo } from '@packages/react';
import * as React from 'react';
import { forwardRef } from 'react';
import { PositionedBox, PositionedBoxProps } from './PositionedBox';

export type AbsoluteProps = PositionedBoxProps;

export const Absolute = createMemo<AbsoluteProps>(
    // eslint-disable-next-line react/display-name
    forwardRef(({ ...props }, ref) => <PositionedBox ref={ref} {...props} />),
    {
        displayName: 'Absolute',
        defaultProps: {
            position: 'absolute',
        },
    },
);
